import {
	ReactElement,
	useState
} from "react";
import {
	Dialog,
	SearchInput,
	Toolbar
} from "client/Components";
import { UserGroupOverviewModel } from "client/Api/UserGroupsManagement/userGroupsManagement";
import { localize } from "client_legacy/ndaw/culture";
import { UserGroupOverview } from "client/Features/Users/UserGroupOverview";
import styles from "../../Users/UserAndUserGroupCollection/UserAndUserGroupOverviews.module.less";

export type SelectUserGroupDialogProps = {
	data: readonly UserGroupOverviewModel[];
	onSelected: (newValue: readonly UserGroupOverviewModel[]) => void;
	onClose: () => void;
};

export const SelectUserGroupDialog = (props: SelectUserGroupDialogProps): ReactElement => {
	const {
		data,
		onSelected,
		onClose
	} = props;

	const [selection, setSelection] = useState<readonly UserGroupOverviewModel[]>([]);
	const [searchTerm, setSearchTerm] = useState<string>("");

	const addHandler = (): void => {
		onSelected(selection);
	};

	return (
		<Dialog trackingId="select-user-group-dialog">
			<Dialog.Header
				title={localize("_AddGroups")}
				onClose={onClose}
			/>
			<Dialog.Body>
				<div className={styles.root} >
					<div className={styles.searchAndTabSelection}>
						<div className={styles.search}>
							<SearchInput
								trackingId="search"
								onChange={setSearchTerm}
							/>
						</div>
					</div>

					<UserGroupOverview
						data={data}
						searchTerm={searchTerm}
						selection={selection}
						onSelectionChange={setSelection}

					/>
				</div>
			</Dialog.Body>
			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						trackingId="add"
						kind="primary"
						text={localize("_Add")}
						onClick={addHandler}
						isDisabled={selection.length === 0}
					/>

					<Toolbar.Button
						trackingId="cancel"
						kind="secondary"
						text={localize("_Cancel")}
						onClick={onClose}
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
SelectUserGroupDialog.displayName = "SelectUserGroupDialog";
